import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ResponsiveActionSidebar from "./ResponsiveActionSidebar";
import "./InstructorStaffLayout.css";

const DEFAULT_LINKS = [
  { path: "/Registrousuario", label: "Registrar usuario / Invitación de pago" },
  { path: "/GestionCursos", label: "Gestionar cursos" },
  { path: "/instructor/progreso-alumnos", label: "Seguimiento de alumnos" },
  { path: "/mensajeria-interna", label: "Mensajería corporativa" },
];

function InstructorStaffLayout({
  title,
  description,
  children,
  links,
  className = "",
  hideSidebar = false,
}) {
  const safeLinks = Array.isArray(links) ? links : DEFAULT_LINKS;
  const containerClassName = ["isl-container", className].filter(Boolean).join(" ");
  const mainClassName = ["isl-main", hideSidebar ? "isl-main--no-sidebar" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClassName}>
      <div className={mainClassName}>
        <div className="isl-content">
          {title ? <h1 className="isl-title">{title}</h1> : null}
          {description ? <p className="isl-desc">{description}</p> : null}
          {children}
        </div>
        {hideSidebar ? null : (
          <ResponsiveActionSidebar
            id="isl-staff-sidebar"
            className="isl-sidebar"
            openClassName="isl-sidebar--open"
            toggleClassName="isl-sidebar-toggle"
            ariaLabel="Navegación del instructor"
          >
            <h4 className="isl-sidebar-title">Acciones</h4>
            <ul className="isl-links">
              {safeLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className={["isl-link", link.variant === "exit" ? "staff-sidebar-exit-button" : ""]
                      .filter(Boolean)
                      .join(" ")}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </ResponsiveActionSidebar>
        )}
      </div>
    </div>
  );
}

export default InstructorStaffLayout;

InstructorStaffLayout.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      variant: PropTypes.oneOf(["exit"]),
    }),
  ),
  className: PropTypes.string,
  hideSidebar: PropTypes.bool,
};

InstructorStaffLayout.defaultProps = {
  title: "",
  description: "",
  children: null,
  links: undefined,
  className: "",
  hideSidebar: false,
};
